import {
  GET_QRPAYMENTREPORTS,
  POST_QRPAYMENTREPORT,
} from "resources/actionTypes";

/**
 * Fetch the paginated QR Payment report list.
 * payload shape: { page, pageSize, dateFrom, dateTo, city, companyId,
 *                  tripStatus, paymentStatus, settlementStatus }
 */
export function getQrPaymentReports(payload) {
  return {
    type: GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_REQUESTED,
    payload,
  };
}

/**
 * Request a CSV/PDF report export or trigger email notification.
 * payload shape: { startDate, endDate, format, filters, notifyOnComplete }
 * Extra key `navigate` can be passed so the saga can redirect to
 * /report-generate on success (same pattern as billing).
 */
export function postQrPaymentReport(payload) {
  return {
    type: POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_REQUESTED,
    payload,
  };
}
